/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { faLongArrowRight } from '@fortawesome/pro-solid-svg-icons'
import Radio from '../../components/form/Radio'
import { toggleRadioBtns } from '../../utilities/base'
import Button from '../../components/form/Button'

const QuestionMultiSingle = ({ question, onContinue, buttonStyle }) => {
  const [choiceArray, setChoiceArray] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)

  const handleContinue = () => {
    console.log(selectedValue)
    onContinue(selectedValue)
  }

  // new question of the same type -> reset
  useEffect(() => {
    const choices = question.options.map((option, i) => {
      return { label: option.value, id: i, selected: false }
    })
    setChoiceArray(choices)
    setSelectedValue(null)
  }, [question])

  return (
    <>
      {choiceArray.map((choice) => {
        return (
          <div key={choice.id}>
            <Radio
              checked={choice.selected}
              label={choice.label}
              id={choice.id}
              onClick={(e) => {
                toggleRadioBtns(e, choiceArray, setChoiceArray)
                setSelectedValue(choice.label)
              }}
            />
          </div>
        )
      })}

      <div className="pt-medium">
        <Button
          label=""
          icon={faLongArrowRight}
          customCSS={{ fontSize: '1.5em', margin: 'auto', ...buttonStyle }}
          clickHandler={handleContinue}
          disabled={!selectedValue}
        />
      </div>
    </>
  )
}

QuestionMultiSingle.defaultProps = {
  buttonStyle: {},
}

QuestionMultiSingle.propTypes = {
  question: PropTypes.shape({
    options: PropTypes.array.isRequired,
    logic: PropTypes.array.isRequired,
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  buttonStyle: PropTypes.object,
}

export default QuestionMultiSingle
